import React, { Component } from 'react';
import SelectWithCustomLabel from './SelectWithCustomLabel';

class SortFilter extends Component {
    render() {
        const { data, checked, change } = this.props;
        return (
            <div className={this.props.class}>
                <SelectWithCustomLabel
                    data={data}
                    markedKey="value"
                    checked={checked}
                    placeholder="Select Destination"
                    onChange={e => change(e)}
                />
            </div>
        );
    }
}

export default SortFilter;